export default __webpack_public_path__ + "static/media/fa-regular-400.19e27d34.svg";